import React, { useState } from "react";
import { showSuccessMessage, showErrorMessage } from "../utils/alertHelper";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const baseURL = process.env.REACT_APP_BASE_URL;
  
    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${baseURL}/authentication`, {
                username,
                password,
            });

            if (response.data.status) {
                showSuccessMessage("Login successful!");
                
                // Store authentication details
                localStorage.setItem("token", response.data.token);
                localStorage.setItem("login_user", JSON.stringify(response.data.user));
                localStorage.setItem("isAuthenticated", "true");

                // Load additional data
                await loadData();

                // Redirect to intended page or dashboard
                const redirectTo = location.state?.from || "/dashboard";
                setTimeout(() => {
                    navigate(redirectTo, { replace: true });
                }, 1000);
            } else {
                showErrorMessage(response.data.message || "Invalid credentials. Please try again.");
            }
        } catch (err) {
            showErrorMessage(err.response?.data?.message || "An error occurred while logging in.");
        }
    };

    const loadData = async () => {
        try {
            const token = localStorage.getItem("token");
            const [productsRes, customersRes, suppliersRes, posSettingsRes] = await Promise.all([
                axios.get(`${baseURL}/products`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${baseURL}/customers`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${baseURL}/suppliers`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${baseURL}/pos-settings`, { headers: { Authorization: `Bearer ${token}` } })
            ]);
           console.log(productsRes.data);
            localStorage.setItem("products", JSON.stringify(productsRes.data));
            localStorage.setItem("customers", JSON.stringify(customersRes.data));
            localStorage.setItem("suppliers", JSON.stringify(suppliersRes.data));
            localStorage.setItem("posSettings", JSON.stringify(posSettingsRes.data));
        } catch (error) {
            console.error("Error loading data:", error);
        }
    };

    return (
      <div className="container-fluid vh-100 d-flex align-items-center justify-content-center">
        <motion.div
          className="row w-75 shadow-lg rounded overflow-hidden"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          {/* Left Section: Login Form */}
          <div className="col-md-6 bg-white d-flex flex-column align-items-center justify-content-center p-5">
            <motion.img
              src="/gatewaypos.png"
              alt="Logo"
              className="mb-3"
              style={{ width: "35%" }}
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.3 }}
            />
            <motion.h3
              className="mb-4 text-primary fw-bold"
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.6 }}
            >
              Welcome Back!
            </motion.h3>
            <p className="text-muted mb-4">Enter your credentials to access your account</p>
  
            <form onSubmit={handleLogin} className="w-100">
              <motion.div
                className="mb-3"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5 }}
              >
                <label className="form-label fw-semibold">Username</label>
                <input
                  type="text"
                  className="form-control rounded-pill"
                  value={username}
                  name="username"
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  style={{ transition: "0.3s", border: "1px solid #ccc" }}
                  onFocus={(e) => (e.target.style.border = "2px solid #007bff")}
                  onBlur={(e) => (e.target.style.border = "1px solid #ccc")}
                />
              </motion.div>
  
              <motion.div
                className="mb-3"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.7 }}
              >
                <label className="form-label fw-semibold">Password</label>
                <input
                  type="password"
                  name="password"
                  className="form-control rounded-pill"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={{ transition: "0.3s", border: "1px solid #ccc" }}
                  onFocus={(e) => (e.target.style.border = "2px solid #007bff")}
                  onBlur={(e) => (e.target.style.border = "1px solid #ccc")}
                />
              </motion.div>
  
              <motion.button
                type="submit"
                className="btn btn-primary w-100 rounded-pill"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Login
              </motion.button>
            </form>
            <p className="mt-3 text-muted small">Version 1.0.0</p>
          </div>
  
          {/* Right Section: Advertisement */}
          <motion.div
            className="col-md-6 d-flex flex-column align-items-center justify-content-center text-white bg-primary p-5"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <motion.h4
              className="text-white fw-bold"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              Discover Amazing Features
            </motion.h4>
            <p className="text-white-50">Fast, Secure & Reliable</p>
            <motion.img
              src="/promo.png"
              alt="Ad Banner"
              className="img-fluid rounded shadow"
              style={{ maxWidth: "80%" }}
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.5 }}
            />
          </motion.div>
        </motion.div>
      </div>
    );
};

export default Login;